/*
 * Text Row Mobile Fade Carousel
 * Auto-fades between grid items on mobile viewports.
 * Activated by data-mobile-autoplay attribute on .section-columns.
 * Uses .grid--mobile-fade class (applied via Liquid layout_mobile setting).
 */
(function () {
  var MOBILE_BREAKPOINT = 749;
  var TRANSITION_MS = 300;

  document.querySelectorAll('.section-columns[data-mobile-autoplay]').forEach(function (section) {
    var speed = parseInt(section.dataset.mobileAutoplaySpeed || '2', 10) * 1000;
    var grid = section.querySelector('.grid--mobile-fade');
    if (!grid) return;

    var items = grid.querySelectorAll(':scope > .grid-item');
    if (items.length < 2) return;

    var currentIndex = 0;
    var timer = null;
    var active = false;

    function showItem(index) {
      items.forEach(function (item, i) {
        if (i === index) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }

    function advance() {
      currentIndex = (currentIndex + 1) % items.length;
      showItem(currentIndex);
    }

    function startTimer() {
      stopTimer();
      timer = setInterval(advance, speed);
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function activate() {
      if (active) return;
      active = true;
      currentIndex = 0;
      showItem(0);
      startTimer();
    }

    function deactivate() {
      if (!active) return;
      active = false;
      stopTimer();
      items.forEach(function (item) {
        item.classList.remove('is-active');
      });
    }

    function checkViewport() {
      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        activate();
      } else {
        deactivate();
      }
    }

    // Pause when section is not visible
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!active) return;
          if (entry.isIntersecting) {
            startTimer();
          } else {
            stopTimer();
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);

    // Respect reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Respond to viewport changes
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkViewport, 150);
    });

    checkViewport();
  });
})();
